'use strict';


function not_implemented(s) {
  var str = s + " not implemented by BuckleScript yet\n";
  throw new Error(str);
}

exports.not_implemented = not_implemented;
/* No side effect */



//////////////////
// WEBPACK FOOTER
// ./~/bs-platform/lib/js/caml_missing_polyfill.js
// module id = 567
// module chunks = 168707334958949